import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { getProjectTemplates } from "../graphql/queries";
import { Project } from "db/definitions";
import { recordSentry } from "./recordSentry";

const client = generateClient({ authMode: "userPool" });

async function handleGetProjectTemplates(project: Project): Promise<string[] | undefined> {
	interface GetProjectTemplatesResponse {
		getProjectTemplates: string;
	}
	try {
		const response = (await client.graphql({
			query: getProjectTemplates,
			authMode: "userPool",
			variables: {
				projectId: project.id,
			},
		})) as GraphQLResult<GetProjectTemplatesResponse>;
		const formTemplateIdsString = response.data.getProjectTemplates;

		return JSON.parse(formTemplateIdsString) as string[];
	} catch (error) {
		recordSentry({ error });
	}
}

export default handleGetProjectTemplates;
